import React, { useState } from "react";
import "../cart/style/addcart.css";
import "../cart/style/customermodel.css";
import toast, { Toaster } from "react-hot-toast";
import "react-loading-skeleton/dist/skeleton.css";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../ProductDetail/service/productcart.service";
import { getCustomers } from "../cart/service/Customers.service";
import { persistCartContext } from "../checkout/service/cart.service";
import { setCartCount } from "../cart/redux/cartSlice";

function AddCart({ sizes = [] }) {

const dispatch = useDispatch();
const cartCount = useSelector((state) => Number(state.cart.cartCount) || 0);
const [quantities, setQuantities] = useState({});
const [loadingId, setLoadingId] = useState(null);
const [showModal, setShowModal] = useState(false);
const [customers, setCustomers] = useState([]);
const [search, setSearch] = useState("");
const [selectedProduct, setSelectedProduct] = useState(null);
const [selectedCustomer, setSelectedCustomer] = useState(null);
const handleQuantityChange = (product_id, quantity) => {
  console.log({
    product_id: product_id,
    quantity: quantity
  });
};

const loadCustomers = async () => {
    try {
      const customerList = await getCustomers({});
      setCustomers(Array.isArray(customerList) ? customerList : []);
    } catch (error) {
      console.log(error);
      toast.error("Unable to load customers");
    }
  };

  // Cart Icon Click
  const handleAddToCart = async (item) => {
  // Customer already selected -> Direct add to cart
  if (selectedCustomer) {
    return handleCustomerSelect(selectedCustomer, item);
  }

  try {
    const res = await getCustomers(982);
    const list = res?.data || res?.customers || res || [];
    setCustomers(Array.isArray(list) ? list : []);
    setSelectedProduct(item);
    setSearch("");
    setShowModal(true);
  } catch (error) {
    toast.error("Unable to load customers");
  }
};

const handleCustomerSelect = async (
  customer,
  product = selectedProduct
) => {
  if (!product) return;

  const customerId =
    customer.customerId ||
    customer.customer_id ||
    customer.id;

  setSelectedCustomer(customer);

  const qty = quantities[product.product_id] ?? 1;

  try {
    setLoadingId(product.product_id);

    const payload = {
      cart_type: "fresh",
      user_id: 1,
      customer_id: customerId,
      product_listing_id:
        product.product_listing_id || product.product_id,
      qty,
    };

    const res = await addToCart(payload);

    if (res?.success !== false) {
      persistCartContext({
        cartType: "fresh",
        userId: 1,
        customerId,
      });

      dispatch(setCartCount(cartCount + qty));

      toast.success("Added to Cart");
    }

    setShowModal(false);
    setSelectedProduct(null);
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Failed to add cart"
    );
  } finally {
    setLoadingId(null);
  }
};

const getCustomerName = (customer) =>
  customer.accountName ||
  customer.customerName ||
  customer.customer_name ||
  customer.name ||
  "";

const filteredCustomers =
  search.trim().length > 0
    ? customers.filter((customer) =>
        getCustomerName(customer)
          .toLowerCase()
          .includes(search.trim().toLowerCase())
      )
    : [];

  return (
    <>
      <Toaster position="top-right" />

      <div className="TableBoxcart" style={{ marginTop: 0 }}>
        <div className="table-responsive">
          <div className="table-box-content">
            <div className="table-header-fixed">
              <table className="table table-sm table-striped mb-0">
                <thead className="text-center">
                  <tr>
                    <th>Size</th>
                    <th style={{ width: "14%" }}>Barcode</th>
                    <th>Shape</th>
                    <th>Stock</th>
                    <th>Ord. Qty</th>
                    <th>MRP</th>
                    <th>Cart</th>
                    <th>Wishlist</th>
                  </tr>
                </thead>
              </table>
            </div>

            <div className="table-body-scroll">
              <table className="table table-sm table-striped mb-0">
                <tbody>

                  {sizes.length > 0 ? (
                    sizes.map((item) => (
                      <tr key={item.product_id}>
                        <td>{item.size}</td>

                        <td style={{ width: "19%" }}>
                          {item.barcode}
                        </td>

                        <td>{item.shape}</td>

                        <td className="text-center">
                          {item.avail_stock}
                        </td>

                        <td className="text-center">
                          {/* <select
                            className="form-control form-control-sm select-List"
                            value={quantities[item.product_id] ?? 1}
                            onChange={(e) =>
                              setQuantities((prev) => ({
                                ...prev,
                                [item.product_id]: Number(e.target.value),
                              }))
                            }
                          >
                            {[...Array(11).keys()].map((i) => (
                              <option key={i+1} value={i+1}>
                                {i+1}
                              </option>
                            ))}
                          </select> */}

                          <div className="d-flex align-items-center justify-content-center">
  <button
    type="button"
    className="btn btn-sm btn-outline-secondary"
    onClick={() => {
      const qty = Math.max(
        1,
        Number(quantities[item.product_id] || 1) - 1
      );

      setQuantities((prev) => ({
        ...prev,
        [item.product_id]: qty,
      }));

      handleQuantityChange(item.product_id, qty);
    }}
  >
    -
  </button>

  <input
    type="number"
    className="form-control form-control-sm text-center mx-1 select-List"
    value={quantities[item.product_id] ?? 1}
    min="1"
    max="20"
    style={{
      width: "43px",
      fontSize: "13px"
    }}
    onChange={(e) => {
      let qty = Number(e.target.value);

      if (!qty || qty < 1) qty = 1;
      if (qty > 20) qty = 20;

      setQuantities((prev) => ({
        ...prev,
        [item.product_id]: qty,
      }));

      handleQuantityChange(item.product_id, qty);
    }}
  />

  <button
    type="button"
    className="btn btn-sm btn-outline-secondary"
    onClick={() => {
      const qty = Math.min(
        20,
        Number(quantities[item.product_id] || 1) + 1
      );

      setQuantities((prev) => ({
        ...prev,
        [item.product_id]: qty,
      }));

      handleQuantityChange(item.product_id, qty);
    }}
  >
    +
  </button>
</div>
                        </td>

                        <td>{item.mrp}</td>

                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-outline-secondary addtocart"
                                disabled={loadingId === item.product_id}
                                onClick={() => handleAddToCart(item)}
                              >
                                {loadingId === item.product_id ? (
                                  "Adding..."
                                ) : (
                                  <i className="bi bi-cart-plus"></i>
                                )}
                              </button>
                            </td>

                        <td className="text-center">
                          <button className="btn btn-outline-secondary WishListbtn">
                            <i className="bi bi-heart"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-3">
                        No sizes available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


<Modal
  show={showModal}
  onHide={() => {
    setShowModal(false);
    setSearch("");
    setSelectedProduct(null);
  }}
  className="model001"
  style={{ background:"#0000008a"}}

>
  <Modal.Body>
    <input
      type="text"
      className="form-control"
      placeholder="Search Customer..."
      autoFocus
      value={search}
      onChange={(e) => setSearch(e.target.value)}
     />

    {search.trim() !== "" && (
      <div
        className="list-group mt-2"
        style={{
          maxHeight: "250px",
          overflowY: "auto",
        }}
      >
        {filteredCustomers.length > 0 ? (
          filteredCustomers.map((customer) => (
            <button
              type="button"
              key={
                customer.customerId ||
                customer.customer_id ||
                customer.id
              }
              className="list-group-item list-group-item-action text-start"
              onClick={() => handleCustomerSelect(customer)}
            >
              {getCustomerName(customer)}
            </button>
          ))
        ) : (
          <div className="list-group-item text-center text-muted">
            No Customer Found
          </div>
        )}
      </div>
    )}
  </Modal.Body>
</Modal>



    </>
  );
}
export default AddCart;